import { useLocale } from "../i18n/useLocale";
import { getMobileAppStoreLinks } from "../config/mobileAppLinks";

const STEP_KEYS = [
  "web.mobileAppPromo.steps.plan",
  "web.mobileAppPromo.steps.send",
  "web.mobileAppPromo.steps.workshop",
];

/**
 * @param {{
 *   variant: "werkplan" | "simulator" | "planner" | "guide",
 *   guidePageId?: string,
 *   layout?: "phone" | "tablet",
 *   enableHandoff?: boolean,
 *   onHandoff?: () => void,
 *   onDismiss?: () => void,
 * }} props
 */
export function MobileAppPromoCard({
  variant,
  guidePageId,
  layout = "phone",
  enableHandoff = false,
  onHandoff,
  onDismiss,
}) {
  const { display } = useLocale();
  const storeLinks = getMobileAppStoreLinks();
  const isPhone = layout === "phone";

  const titleKey = variant === "guide" && guidePageId
    ? `web.mobileAppPromo.guide.${guidePageId}.title`
    : variant === "simulator"
      ? "web.mobileAppPromo.simulator.title"
      : variant === "planner"
        ? "web.mobileAppPromo.planner.title"
        : isPhone
          ? "web.mobileAppPromo.werkplan.titlePhone"
          : "web.mobileAppPromo.werkplan.titleTablet";

  const bodyKey = variant === "guide" && guidePageId
    ? `web.mobileAppPromo.guide.${guidePageId}.body`
    : variant === "simulator"
      ? "web.mobileAppPromo.simulator.body"
      : variant === "planner"
        ? "web.mobileAppPromo.planner.body"
        : isPhone
          ? "web.mobileAppPromo.werkplan.bodyPhone"
          : "web.mobileAppPromo.werkplan.bodyTablet";

  const showSteps = variant !== "planner";
  const showStoreLinks = Boolean(storeLinks.appStore || storeLinks.playStore);

  return (
    <aside
      aria-labelledby={`mobile-app-promo-title-${variant}`}
      className={`mobile-app-promo mobile-app-promo--${variant} mobile-app-promo--${layout} no-print`}
    >
      <div className="mobile-app-promo-header">
        <p className="mobile-app-promo-eyebrow">{display.t("web.mobileAppPromo.eyebrow")}</p>
        {onDismiss ? (
          <button
            aria-label={display.t("web.mobileAppPromo.dismiss")}
            className="mobile-app-promo-dismiss"
            onClick={onDismiss}
            type="button"
          >
            ×
          </button>
        ) : null}
      </div>
      <h2 className="mobile-app-promo-title" id={`mobile-app-promo-title-${variant}`}>
        {display.t(titleKey)}
      </h2>
      <p className="mobile-app-promo-body">{display.t(bodyKey)}</p>

      {showSteps ? (
        <ol className="mobile-app-promo-steps">
          {STEP_KEYS.map((key, index) => (
            <li key={key} className="mobile-app-promo-step">
              <span aria-hidden="true" className="mobile-app-promo-step-badge">{index + 1}</span>
              <span>{display.t(key)}</span>
            </li>
          ))}
        </ol>
      ) : null}

      <div className="mobile-app-promo-actions">
        {enableHandoff && onHandoff ? (
          <button
            className="secondary-button mobile-app-promo-handoff"
            onClick={onHandoff}
            type="button"
          >
            {display.t("web.mobileAppPromo.handoff")}
          </button>
        ) : null}

        {showStoreLinks ? (
          <div className="mobile-app-promo-stores">
            {storeLinks.appStore ? (
              <a
                className="mobile-app-promo-store-link"
                href={storeLinks.appStore}
                rel="noopener noreferrer"
                target="_blank"
              >
                {display.t("web.mobileAppPromo.appStore")}
              </a>
            ) : null}
            {storeLinks.playStore ? (
              <a
                className="mobile-app-promo-store-link"
                href={storeLinks.playStore}
                rel="noopener noreferrer"
                target="_blank"
              >
                {display.t("web.mobileAppPromo.playStore")}
              </a>
            ) : null}
          </div>
        ) : null}
      </div>

      <p className="mobile-app-promo-note">{display.t("web.mobileAppPromo.note")}</p>
    </aside>
  );
}
